angular.module('gym.tasks', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.tasks', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.tasks.list', {
    url: '/tasks?tab&useDefaultDateFilterSetter',
    template: require('templates/gyms/tasks/index.html.slim'),
    reloadOnSearch: false
  });
}]);
